import React from 'react';
export function GlobeSpindleIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    d: "M16.38.876L15.73.5l-.75 1.298.649.376a9.25 9.25 0 01-4.625 17.263A9.204 9.204 0 016.38 18.2l-.65-.376-.75 1.299.649.375a10.69 10.69 0 004.624 1.413v1.026h-4.25v1.5h10v-1.5h-4.25V20.91c5.588-.384 10.001-5.039 10.001-10.724 0-3.98-2.163-7.454-5.374-9.311z"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.001 3.259a8 8 0 11-8 13.856 8 8 0 018-13.856zm-7.25 12.557c.096.055.658.203 1.86-.635.958-.667 2.016-1.777 2.948-3.228L8.694 9.72c-.79 1.534-1.223 3.005-1.322 4.168-.125 1.46.285 1.873.38 1.928zm1.692-7.395l3.867 2.232c.79-1.533 1.222-3.004 1.322-4.167.124-1.46-.285-1.873-.38-1.928-.096-.055-.659-.204-1.86.635-.958.667-2.016 1.777-2.949 3.228zm.694 8.21c1.262-.786 2.598-2.161 3.723-3.928l2.358 1.362a6.506 6.506 0 01-6.08 2.566zm4.473-5.227l2.358 1.362a6.506 6.506 0 00-.818-6.55c-.05 1.486-.573 3.33-1.54 5.188zm-2.745-7.661c-1.261.786-2.597 2.16-3.722 3.927L5.784 6.31a6.506 6.506 0 016.081-2.566zM5.853 14.157a6.506 6.506 0 01-.819-6.55L7.393 8.97c-.967 1.857-1.49 3.701-1.54 5.187z"
  }));
}